module.exports = __webpack_public_path__ + "assets/img/vue_template_class_computed.c42aa145.jpg";